// Entry point for the build script in your package.json
import "./dashboard";
import "@hotwired/turbo-rails";
import "./controllers";
import bulmaCalendar from "bulma-calendar/dist/js/bulma-calendar.min.js";
bulmaCalendar.attach('[type="date"]', options);
import "trix";
import "@rails/actiontext";
